/**
 * Central API base URL. Switch environments via env files only:
 *   .env.development  — npm start
 *   .env.production   — npm run build
 *   .env              — fallback for both
 *
 * App code always uses paths relative to this (e.g. `${API_URL}/auth/login`).
 */
const raw = process.env.REACT_APP_API_URL || 'https://api.tracktcrm.com/api';
export const API_URL = String(raw).replace(/\/$/, '');
